const STORAGE_KEY = "almoune_sav_threads";

const nowISO = () => new Date().toISOString();

export const defaultSAVThreads = [
  {
    id: 2079,
    clientName: "Eric Grange",
    clientEmail: "eric.grange@example.com",
    type: "Service client",
    language: "Français",
    status: "En attente 2",
    employee: "—",
    isPrivate: false,
    createdAt: "2026-07-25T09:12:00Z",
    lastMessageDate: "2026-07-26T14:05:00Z",
    orders: [
      { id: "27175", number: 27175, total: 62.87, date: "2026-07-24T10:00:00Z", status: "Livree" },
      { id: "27182", number: 27182, total: 34.50, date: "2026-07-25T15:30:00Z", status: "Preparation" },
    ],
    messages: [
      {
        type: "client",
        author: "Eric Grange",
        content:
          "Bonjour, j'ai passé commande hier (#27175) et je n'ai pas reçu de confirmation de livraison. Pourriez-vous me tenir au courant ? Merci.",
        date: "2026-07-25T09:12:00Z",
      },
      {
        type: "client",
        author: "Eric Grange",
        content:
          "Je relance ma demande, toujours pas de nouvelles. Est-ce que ma commande est bien partie ?",
        date: "2026-07-26T14:05:00Z",
      },
    ],
  },
  {
    id: 2078,
    clientName: "Nadine Khoury",
    clientEmail: "nadine.khoury@email.com",
    type: "Service client",
    language: "Français",
    status: "En attente 1",
    employee: "—",
    isPrivate: false,
    createdAt: "2026-07-22T11:00:00Z",
    lastMessageDate: "2026-07-24T16:20:00Z",
    orders: [{ id: "27012", number: 27012, total: 87.50, date: "2026-07-20T14:30:00Z", status: "Livree" }],
    messages: [
      {
        type: "client",
        author: "Nadine Khoury",
        content:
          "Bonjour, une cuve d'huile d'olive est arrivée cassée dans ma livraison. Puis-je obtenir un remboursement ?",
        date: "2026-07-22T11:00:00Z",
      },
    ],
  },
  {
    id: 2077,
    clientName: "Karim Hanna",
    clientEmail: "karim.hanna@email.com",
    type: "Webmaster",
    language: "Français",
    status: "Ouvert",
    employee: "—",
    isPrivate: true,
    createdAt: "2026-07-21T08:30:00Z",
    lastMessageDate: "2026-07-21T08:30:00Z",
    orders: [],
    messages: [
      {
        type: "client",
        author: "Karim Hanna",
        content:
          "Bonjour, je ne parviens pas à me connecter à mon compte sur le site. Le bouton de connexion semble ne rien faire.",
        date: "2026-07-21T08:30:00Z",
      },
    ],
  },
];

const normalize = (t) => ({
  id: Number(t.id),
  clientName: t.clientName || t.client_name || "",
  clientEmail: t.clientEmail || t.client_email || "",
  type: t.type || "Service client",
  language: t.language || "Français",
  status: t.status || "Ouvert",
  employee: t.employee || "—",
  isPrivate: Boolean(t.isPrivate),
  createdAt: t.createdAt || t.created_at || nowISO(),
  lastMessageDate: t.lastMessageDate || t.last_message_date || t.createdAt || nowISO(),
  orders: Array.isArray(t.orders) ? t.orders : [],
  messages: Array.isArray(t.messages) ? t.messages : [],
});

const readCache = () => {
  if (typeof window === "undefined") return defaultSAVThreads.map(normalize);
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return defaultSAVThreads.map(normalize);
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return defaultSAVThreads.map(normalize);
    if (!parsed.length) return parsed.map(normalize);
    return parsed.map(normalize);
  } catch {
    return defaultSAVThreads.map(normalize);
  }
};

const writeCache = (threads) => {
  const normalized = threads.map(normalize);
  if (typeof window !== "undefined") {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(normalized));
  }
  return normalized;
};

export const loadSAVThreads = async () => readCache();

export const getSAVThreadById = async (id) =>
  readCache().find((t) => Number(t.id) === Number(id)) || null;

export const saveSAVThread = async (thread) => {
  const normalized = normalize({
    ...thread,
    id: Number(thread.id) || (readCache().reduce((m, t) => Math.max(m, Number(t.id) || 0), 0) + 1),
  });
  const all = readCache();
  const idx = all.findIndex((t) => Number(t.id) === normalized.id);
  const updated = idx >= 0 ? all.map((t, i) => (i === idx ? normalized : t)) : [...all, normalized];
  return writeCache(updated);
};

export const addSAVMessage = async (threadId, content, senderName) => {
  const all = readCache();
  const idx = all.findIndex((t) => Number(t.id) === Number(threadId));
  if (idx === -1) return readCache();
  const thread = all[idx];
  const updated = {
    ...thread,
    lastMessageDate: nowISO(),
    messages: [
      ...thread.messages,
      {
        type: "admin",
        author: senderName || "Admin",
        content,
        date: nowISO(),
      },
    ],
  };
  all[idx] = updated;
  return writeCache(all);
};

export const updateSAVStatus = async (threadId, status, employee) => {
  const all = readCache();
  const idx = all.findIndex((t) => Number(t.id) === Number(threadId));
  if (idx === -1) return readCache();
  const thread = all[idx];
  all[idx] = {
    ...thread,
    status: status || thread.status,
    employee: employee !== undefined ? employee : thread.employee,
    lastMessageDate: nowISO(),
  };
  return writeCache(all);
};
